import { createSelector } from 'reselect';

type MenuSelector = ReturnType<typeof menusSelector>;
const menusSelector = (state: AppState) => state.menus.menus || [];

export const getUnassignedMenus = createSelector<AppState, MenuSelector, any>(
  [menusSelector],
  (menus) => {
    return menus.filter((menu) => menu.StoreNames === undefined || menu.StoreNames.length === 0);
  }
);
